import { render, staticRenderFns } from "./DomainAnalysis.vue?vue&type=template&id=4f1e3cf6&scoped=true"
import script from "./DomainAnalysis.vue?vue&type=script&lang=js"
export * from "./DomainAnalysis.vue?vue&type=script&lang=js"
import style0 from "./DomainAnalysis.vue?vue&type=style&index=0&id=4f1e3cf6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e3cf6",
  null
  
)

export default component.exports